const state = () => ({
  evaluation:null,
  evaluations:[],
  questionlist:null,
  inputfields:[],
  sections:[],
  parentsections:[],
  active_parent_section_id:null,
  show_null_modal:false,
  show_evidence_modal:false,
  active_section:null,
  active_inputfield:null,
  section_loading:true,
  flow_videos:null,
  active_video:null,
  flow_process:{items:[],itemcount:0,current_item:null,processed_items:0,progress_percentage:0},
  inputfields_updating:false,
  viewingmode:"submitting",
  nullreasons:[],
  nonconformity_types:[],
  customattributes:[],
  show_finish_modal:false,
  show_correction_request_modal:false,
  ready_to_finish:false,
  first_inputfield_error:null,
  finish_error:false,
  questionlist_conditions:[],
  submitting:false,
  active_project_supplier:null,
  selected_inputfield:null,
  viewing_brand:null,
  calculated_fields:[],
  field_calculation_finished:false,
  calculated_data_to_submit:[],
  submission_queue:[],
});
const getters = {
  evaluation(state){
    return state.evaluation
  },
  evaluations(state){
    return state.evaluations
  },
  questionlist(state){
    return state.questionlist
  },
  inputfields(state){
    return state.inputfields
  },
  sections(state){
    return state.sections
  },
  parentsections(state){
    return state.parentsections
  },
  active_parent_section_id(state){
    return state.active_parent_section_id
  },
  show_null_modal(state){
    return state.show_null_modal
  },
  show_evidence_modal(state){
    return state.show_evidence_modal
  },
  active_section(state){
    return state.active_section
  },
  active_inputfield(state){
    return state.active_inputfield
  },
  section_loading(state){
    return state.section_loading
  },
  flow_videos(state){
    return state.flow_videos
  },
  active_video(state){
    return state.active_video
  },
  flow_process(state){
    return state.flow_process
  },
  inputfields_updating(state){
    return state.inputfields_updating
  },
  viewingmode(state){
    return state.viewingmode
  },
  nullreasons(state){
    return state.nullreasons
  }, 
  nonconformity_types(state){
    return state.nonconformity_types
  },  
  customattributes(state){
    return state.customattributes
  },  
  show_finish_modal(state){
    return state.show_finish_modal
  },  
  show_correction_request_modal(state){
    return state.show_correction_request_modal
  }, 
  first_inputfield_error(state){
    return state.first_inputfield_error
  },
  finish_error(state){
    return state.finish_error
  },
  questionlist_conditions(state){
    return state.questionlist_conditions
  },
  submitting(state){
    return state.submitting
  },
  active_project_supplier(state){
    return state.active_project_supplier
  },
  selected_inputfield(state){
    return state.selected_inputfield
  },
  viewing_brand(state){
    return state.viewing_brand
  },
  calculated_fields(state){
    return state.calculated_fields
  },
  field_calculation_finished(state){
    return state.field_calculation_finished
  },
  calculated_data_to_submit(state){
    return state.calculated_data_to_submit
  },
  submission_queue(state){
    return state.submission_queue
  },
};
const  mutations =  {
  SET_EVALUATION(state,data){
    state.evaluation = data
  },
  SET_EVALUATIONS(state,data){
    state.evaluations = data
  },
  SET_QUESTIONLIST(state,data){
    state.questionlist = data
  },
  SET_INPUTFIELDS(state,data){
    state.inputfields = data
  },
  SET_SECTIONS(state,data){
    state.sections = data
  },
  SET_PARENT_SECTIONS(state,data){
    state.parentsections = data
  },
  SET_ACTIVE_PARENT_SECTION_ID(state,data){
    state.active_parent_section_id = data
  },
  SET_NULL_MODAL(state,data){
    state.show_null_modal = data
  },
  SET_EVIDENCE_MODAL(state,data){
    state.show_evidence_modal = data
  },
  SET_ACTIVE_SECTION(state,data){
    state.active_section = data
  },
  SET_ACTIVE_INPUTFIELD(state,data){
    state.active_inputfield = data
  },
  SET_SECTION_LOADING(state,data){
    state.section_loading = data
  },
  SET_FLOW_VIDEOS(state,data){
    state.flow_videos = data
  },
  SET_ACTIVE_VIDEO(state,data){
    state.active_video = data
  },
  SET_FLOW_PROCESS(state,data){
    state.flow_process = data
  },
  SET_INPUTFIELDS_UPDATING(state,data){
    state.inputfields_updating = data
  },
  SET_MODE(state,data){
    state.viewingmode = data
  },
  SET_NULLREASONS(state,data){
    state.nullreasons = data
  }, 
  SET_NONCONFORMITY_TYPES(state,data){
    state.nonconformity_types = data
  },  
  SET_CUSTOMATTRIBUTES(state,data){
    state.customattributes = data
  },
  SET_SHOW_FINISH_MODAL(state,data){
    state.show_finish_modal = data
  },
  SET_SHOW_CORRECTION_REQUEST_MODEL(state,data){
    state.show_correction_request_modal = data
  },
  SET_FIRST_INPUTFIELD_ERROR(state,data){
    state.first_inputfield_error = data
  },
  SET_FINISH_ERROR(state,data){
    state.finish_error = data
  },
  SET_QUESTIONLIST_CONDITIONS(state,data){
    state.questionlist_conditions = data
  },
  SET_SUBMITTING(state,data){
    state.submitting = data
  },
  SET_ACTIVE_PROJECT_SUPPLIER(state,data){
    state.active_project_supplier = data
  },
  SET_SELECTED_INPUTFIELD(state,data){
    state.selected_inputfield = data
  },
  SET_VIEWING_BRAND(state,data){
    state.viewing_brand = data
  },
  SET_CALCULATED_FIELDS(state,data){
    state.calculated_fields = data
  },
  SET_FIELD_CALCULATION_FINISHED(state,data){
    state.field_calculation_finished = data
  },
  SET_CALCULATED_DATA_TO_SUBMIT(state,data){
    state.calculated_data_to_submit = data
  },
  SET_SUBMISSION_QUEUE(state,data){
    state.submission_queue = data
  },
};
const actions =  {
  setEvaluation({commit},data)  {
    commit("SET_EVALUATION",data)
  },
  setEvaluations({commit},data)  {
    commit("SET_EVALUATIONS",data)
  },
  setQuestionlist({commit},data)  {
    commit("SET_QUESTIONLIST",data)
  },
  setInputfields({commit},data)  {
    commit("SET_INPUTFIELDS",data)
  },
  setSections({commit},data)  {
    commit("SET_SECTIONS",data)
  },
  setParentSections({commit},data)  {
    commit("SET_PARENT_SECTIONS",data)
  },
  setActiveParentSectionId({commit},data)  {
    commit("SET_ACTIVE_PARENT_SECTION_ID",data)
  },
  setNullModal({commit},data)  {
    commit("SET_NULL_MODAL",data)
  },
  setEvidenceModal({commit},data)  {
    commit("SET_EVIDENCE_MODAL",data)
  },
  setActiveSection({commit},data)  {
    commit("SET_ACTIVE_SECTION",data)
  },
  setActiveInputfield({commit},data)  {
    commit("SET_ACTIVE_INPUTFIELD",data)
  },
  setSectionLoading({commit},data)  {
    commit("SET_SECTION_LOADING",data)
  },
  setFlowVideos({commit},data)  {
    commit("SET_FLOW_VIDEOS",data)
  },
  setActiveVideo({commit},data)  {
    commit("SET_ACTIVE_VIDEO",data)
  },
  setFlowProcess({commit},data)  {
    commit("SET_FLOW_PROCESS",data)
  },
  setInputfieldsUpdating({commit},data)  {
    commit("SET_INPUTFIELDS_UPDATING",data)
  },
  setMode({commit},data)  {
    commit("SET_MODE",data)
  },
  setNullreasons({commit},data)  {
    commit("SET_NULLREASONS",data)
  },
  setNonconformityTypes({commit},data)  {
    commit("SET_NONCONFORMITY_TYPES",data)
  },
  setCustomattributes({commit},data)  {
    commit("SET_CUSTOMATTRIBUTES",data)
  },
  setShowFinishModal({commit},data)  {
    commit("SET_SHOW_FINISH_MODAL",data)
  },
  setShowCorrectionRequestModal({commit},data)  {
    commit("SET_SHOW_CORRECTION_REQUEST_MODEL",data)
  },
  setFirstInputfieldError({commit},data)  {
    commit("SET_FIRST_INPUTFIELD_ERROR",data)
  },
  setFinishError({commit},data)  {
    commit("SET_FINISH_ERROR",data)
  },
  setQuestionlistConditions({commit},data)  {
    commit("SET_QUESTIONLIST_CONDITIONS",data)
  },
  setSubmitting({commit},data)  {
    commit("SET_SUBMITTING",data)
  },
  setActiveProjectSupplier({commit},data)  {
    commit("SET_ACTIVE_PROJECT_SUPPLIER",data)
  },
  setSelectedInputfield({commit},data)  {
    commit("SET_SELECTED_INPUTFIELD",data)
  },
  setViewingBrand({commit},data)  {
    commit("SET_VIEWING_BRAND",data)
  },
  setCalculatedFields({commit},data)  {
    commit("SET_CALCULATED_FIELDS",data)
  },
  setFieldCalculationFinished({commit},data)  {
    commit("SET_FIELD_CALCULATION_FINISHED",data)
  },
  setCalculatedDataToSubmit({commit},data)  {
    commit("SET_CALCULATED_DATA_TO_SUBMIT",data)
  },
  setSubmissionQueue({commit},data)  {
    commit("SET_SUBMISSION_QUEUE",data)
  },
}

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};

